import React, { useEffect, useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { CREATE_CREDIT, CREATE_TRANSACTION, filterCredit, UPDATE_CREDIT, UPDATE_TRANSACTION, whoami } from './../../graphqlClient/graphql';
import { useMutation } from '@apollo/client';
import Notifications from './../notifications/Notifications';
import { Button, Container, Typography, List, ListItem, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal, Box, LinearProgress } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
interface form {
    planType: string;

}

const CheckoutForm = ({ planType }: form) => {
    const navigate = useNavigate();
    const stripe: any = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [credit, setCredit] = useState<any>([]);
    const [CreateTransactionMutation, { data }] = useMutation(CREATE_TRANSACTION);
    const [CreateCreditMutation, { data: Credit }] = useMutation(CREATE_CREDIT);
    const [UpdateCreditMutation, { data: UpdateCreditInput }] = useMutation(UPDATE_CREDIT);
    const [UpdateTransactionMutation] = useMutation(UPDATE_TRANSACTION);

     useEffect(() => {
            checkCredit()
            //handleCreateAllCategories()
        }, [])

    const handleAddCredit = async (user: any) => {
        setLoading(true)

        const dataToSend: any = {
            user: user,
            active: true,
            amount: 3,
            amountPdf: 3,
            amountInterview: 1,
            amountVisa: 3,
            type: planType,
            status: 'active',
            expiration: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString(),
        }
        if (planType == 'basic') {
            dataToSend.amount = 10
            dataToSend.amountPdf = 5
            dataToSend.amountInterview = 3
            dataToSend.amountVisa = 5
        } else if (planType == 'plus') {
            dataToSend.amount = 30
            dataToSend.amountPdf = 10
            dataToSend.amountInterview = 5
            dataToSend.amountVisa = 10
        }
        console.log('dataToSend add credit', dataToSend)

        // dataToSend.id = dataToSend._id



        try {

            const createCreditInput = dataToSend
            console.log('createCreditInput', dataToSend)

            const result = await CreateCreditMutation({
                variables: {
                    createCreditInput
                },
                onCompleted: ({ createCredit }) => {

                    console.log('credit created== > ', createCredit);
                    const notData = {
                        type: 'success',
                        message: `Credits created Successfully!`,
                        title: 'wescout',
                        timeOut: 2500,
                        callback: () => { },
                        priority: true,
                    }

                    Notifications(notData)
                    setSuccess(true)
                    setLoading(false)

                    //navigate('/login')
                    //setCompany(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            setLoading(false)
            console.log("Error at create credit", error)

        }
        

    };
    const handleUpdateCredit = async (creditId:any) => {
        let res:any = {}
        const dataToSend = {
            _id: creditId,
            active: false,
        }
        setLoading(true)

        //console.log('dataToSend handleUpdateCredit', dataToSend)
        try {

            const updateCreditInput = dataToSend
            console.log('updateCreditInput', dataToSend)

            const result = await UpdateCreditMutation({
                variables: {
                    updateCreditInput
                },
                onCompleted: ({ updateCredit }) => {

                    console.log('credit updated== > ', updateCredit);
                    if(updateCredit._id){
                        res =  updateCredit
                    }
                    setLoading(false)

                    //navigate('/login')
                    //setCompany(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Error at create credit", error)
            setLoading(false)

        }

        return res;

    };

    const checkCredit = async () => {
        setLoading(true)
        const u: any = await getUser();

        if (!u._id) {
            const notData = {
                type: 'error',
                message: "Undefined User",
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            return
        }

        const objToSend = {
            //startDate,
            //endDate,
            //empresa:empresa
            //category:selectedCategory?._id || '',
            "active": true,
            "user": u._id,
        }
        //setIsLoadingCompaniesByFilter(true)
        console.log('objToSend', objToSend)

        const result = await filterCredit(objToSend)
        console.log('filterCredit result ==>>', result)
        if (result.length == 0) {
            console.log('call add credit')
            //await handleAddCredit(u);
        } else {
            setCredit(result)
            console.log('checkCredit', result)
            console.log('planType', planType)
        }
        setLoading(false)
        return;
    }

    const getUser = async () => {
        try {
            const user: any = await whoami();
            console.log('user ==>>', user)
            return user;
        }
        catch (error) {
            console.log("Erro no getUser >>>>>", error)
            return error;
        }
    }

    const handleAddTransaction = async (data?: any) => {

        const dataToSend = data
        //console.log('dataToSend handleAddTransaction', dataToSend)
        setLoading(true)
        try {

            const createTransactionInput = dataToSend
            console.log('createTransactionInput', dataToSend)

            const result = await CreateTransactionMutation({
                variables: {
                    createTransactionInput
                },
                onCompleted: async ({ createTransaction }) => {

                    console.log('createTransaction == > ', createTransaction);
                    
                    if (createTransaction._id) {
                        const subscription = JSON.parse(createTransaction.message);
                        console.log('Parsed subscription from backend:', subscription);

                        if (createTransaction.status === 'incomplete' || subscription.status === 'incomplete') {
                            // Robustly look for client_secret in both standard and expanded structures
                            const latestInvoice = subscription.latest_invoice;
                            
                            // Check latest_invoice.payment_intent
                            let paymentIntentSecret: string | null = null;
                            if (latestInvoice?.payment_intent) {
                                if (typeof latestInvoice.payment_intent === 'string') {
                                    paymentIntentSecret = latestInvoice.payment_intent; // it's just the ID, frontend will have to handle this
                                } else if (typeof latestInvoice.payment_intent === 'object' && latestInvoice.payment_intent.client_secret) {
                                    paymentIntentSecret = latestInvoice.payment_intent.client_secret;
                                }
                            }

                            // Check pending_setup_intent
                            let setupIntentSecret: string | null = null;
                            if (subscription.pending_setup_intent) {
                                if (typeof subscription.pending_setup_intent === 'string') {
                                    setupIntentSecret = subscription.pending_setup_intent; // just the ID
                                } else if (typeof subscription.pending_setup_intent === 'object' && subscription.pending_setup_intent.client_secret) {
                                    setupIntentSecret = subscription.pending_setup_intent.client_secret;
                                }
                            }
                            
                            const clientSecret = paymentIntentSecret || setupIntentSecret;
                            console.log('[DEBUG] Subscription Object:', subscription);
                            console.log('[DEBUG] latestInvoice.payment_intent:', latestInvoice?.payment_intent);
                            console.log('[DEBUG] pending_setup_intent:', subscription.pending_setup_intent);
                            console.log('[DEBUG] Extracted clientSecret:', clientSecret);

                            if (clientSecret) {
                                console.log(`Confirming subscription. Secret type: ${paymentIntentSecret && typeof paymentIntentSecret === 'string' ? 'PaymentIntent' : 'SetupIntent'}`);
                                console.log('ClientSecret:', clientSecret);
                                
                                let confirmResult: any;
                                if (clientSecret.startsWith('seti_')) {
                                    console.warn('Warning: Stripe returned a SetupIntent instead of a PaymentIntent. No charge will be made now.');
                                    confirmResult = await stripe.confirmCardSetup(clientSecret, {
                                        payment_method: data.message
                                    });
                                } else {
                                    confirmResult = await stripe.confirmCardPayment(clientSecret, {
                                        payment_method: data.message
                                    });
                                }

                                if (confirmResult.error) {
                                    console.error('Stripe confirmation error:', confirmResult.error.message);
                                    const notData = {
                                        type: 'error',
                                        message: `Payment failed: ${confirmResult.error.message}`,
                                        title: 'wescout',
                                        timeOut: 2500,
                                        callback: () => { },
                                        priority: true,
                                    }
                                    Notifications(notData);
                                    setLoading(false);
                                    return;
                                }

                                if (
                                    (confirmResult.paymentIntent && confirmResult.paymentIntent.status === 'succeeded') ||
                                    (confirmResult.setupIntent && confirmResult.setupIntent.status === 'succeeded')
                                ) {
                                    console.log('Confirmation succeeded!', confirmResult);
                                    
                                    const notDataSuccess = {
                                        type: 'success',
                                        message: `Plan Activated Successfully!`,
                                        title: 'wescout',
                                        timeOut: 2500,
                                        callback: () => { },
                                        priority: true,
                                    }
                                    Notifications(notDataSuccess);
                                    
                                    await UpdateTransactionMutation({
                                        variables: {
                                            updateTransactionInput: {
                                                _id: createTransaction._id,
                                                status: 'active',
                                                active: true
                                            }
                                        }
                                    });

                                    if (credit.length) {
                                        for (let a = 0; a < credit.length; a++) {
                                            const crediId = credit[a]._id
                                            await handleUpdateCredit(crediId)
                                        }
                                    }
                                    handleAddCredit(data.user);
                                }
                            } else {
                                console.error('Stripe Error: No clientSecret found in subscription response.', subscription);
                                setError('V2 (NEW CODE): Confirmation secret missing. PI and SetupIntent are empty.');
                            }
                        } else if (createTransaction.status === 'active' || subscription.status === 'active' || subscription.status === 'trialing') {
                            console.log('Subscription already active/trialing.');
                            if (credit.length) {
                                for (let a = 0; a < credit.length; a++) {
                                    const crediId = credit[a]._id
                                    await handleUpdateCredit(crediId)
                                }
                            }
                            handleAddCredit(data.user);
                        }
                    } else {
                        // Backend returned an object without _id, likely an error message.
                        console.error('Failed to create transaction:', createTransaction);
                        const errorMessage = createTransaction.message || 'Payment setup failed. Please check your card info or contact support.';
                        setError(errorMessage);
                        const notData = {
                            type: 'error',
                            message: errorMessage,
                            title: 'wescout',
                            timeOut: 2500,
                            callback: () => { },
                            priority: true,
                        }
                        Notifications(notData);
                        setLoading(false);
                    }
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Error stripe", error.message)

        }
        console.log('Transaction created');
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setLoading(true);

        if (!stripe || !elements) return;

        const cardElement = elements.getElement(CardElement);

        try {
            const res = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });
            console.log('res', res)
            const paymentMethod = res.paymentMethod
            const userCheck: any = await getUser();
            // Enviar para o backend para criar a assinatura
            if (!paymentMethod?.id) {
                console.error('Failed to create payment method', paymentMethod);
                throw new Error('Payment method creation failed');
                return;
            }
            const dataToSend = {
                user: userCheck._id,
                message: paymentMethod.id,
                planType: planType,
                email: userCheck.email,
                name: planType == 'basic' ? 'Most Popular' : 'Best Value'
            }
            handleAddTransaction(dataToSend)

        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        {loading ? (
                            <Box sx={{ width: '100%', maxWidth:800,margin:'0 auto' }}>
                                <LinearProgress />
                            </Box>
                        ) : null}
            {
                !success ? <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: 25 }}>
                        <CardElement />
                    </div>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <Button type="submit" disabled={loading || !stripe}>
                        {loading ? 'Processing...' : 'Subscribe to plan'}
                    </Button>
                </form>
                    : <>
                        <p>Subscription successful! Thank you for joining us.</p>
                        <Button onClick={() => { navigate('/invoices') }}>Check your invoice here</Button>
                    </>
            }
        </>


    );
};

export default CheckoutForm;